import { FormattedMessage } from 'react-intl';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

type StatusRollbackDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  statusRollbackPayload: {
    fromLabel: string;
    toLabel: string;
  } | null;
};

const StatusRollbackDialog = ({ open, onClose, onConfirm, statusRollbackPayload }: StatusRollbackDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage id="effortTracing.statusRollbackConfirmTitle" defaultMessage="Emin misiniz?" />
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mt: 1 }}>
          <FormattedMessage
            id="effortTracing.statusRollbackConfirmText"
            defaultMessage="Statü geriye alınacak: {from} → {to}. Devam etmek istiyor musunuz?"
            values={{
              from: statusRollbackPayload?.fromLabel ?? '',
              to: statusRollbackPayload?.toLabel ?? '',
            }}
          />
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">
          <FormattedMessage id="forgotPassword.cancel" defaultMessage="Vazgeç" />
        </Button>

        <Button onClick={onConfirm} variant="contained">
          <FormattedMessage id="forgotPassword.continue" defaultMessage="Devam" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default StatusRollbackDialog;
